export enum FeatureGate {
  BOOKING_CAPABILITY = 'booking_capability',
  BOOKING_CAPABILITY_V3 = 'booking_capability_v3',
  US_FI_PHONE_NUMBERS_SUPPORT = 'us_fi_phone_numbers_support',
  PHILIPPINES_LANGUAGE_SUPPORT = 'philippines_language_support',
  INTEGRATIONS = 'integrations',
}
